import {
  FETCH_TRIP_COUNT_SUCCESS,
  FETCH_OGS_COUNT_SUCCESS,
} from '../constant';
// import { logErrorMessage } from './LogErrorMessage';
// import { invokeService } from '../services';

// const {
//   VACATION_SERVICE,
// } = window.weeksWebCloudConfig;

/** Returns Trip Count Success Object */
export const fetchTripCountSuccess = response => ({
  type: FETCH_TRIP_COUNT_SUCCESS,
  payload: {
    ...response,
  },
});

/** Returns Ongoing Trips Count Success Object */
export const fetchOgsCountSuccess = response => ({
  type: FETCH_OGS_COUNT_SUCCESS,
  payload: {
    ...response,
  },
});

/**
 * This action is for fetching the vacation count
 * @param {*} leadId
 * @deprecated not being used.
 */
/* export const getTripCount = leadId => async (dispatch) => {
  const memberUrl = `${VACATION_SERVICE}/${leadId}/vacations/count`;
  // const memberUrl = MEMBERINFO; use this for outside cognizant

  //Remove all the custom headers when AWS will be ready

  const customHeaders = {
    ConsumerChannel: 'Web',
    MemberType: 'POINTS',
    OperatorId: 'WEB00USER',
  };
  const serviceResponse = await invokeService({
    resource: memberUrl,
    method: 'GET',
    customHeaders,
  });
  if (serviceResponse.status === 200) {

      // error messsage status check logic changed.
      // Always we have to check the status.

    dispatch(fetchTripCountSuccess(serviceResponse.data));
  } else {
    // dispatch(fetchMemberInfoError(serviceResponse.message));
    // dispatch(logErrorMessage(serviceResponse, 'Trip count service'));
  }
}; */
